import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconsModule } from '../../../icons/icons.module';

@Component({
  selector: 'zikatagov-menu-item',
  template: `
    <li>
      <a
        class="nav-link d-flex align-items-center"
        [class.active]="isActive"
        [class.collapsed]="showOnlyIcons"
        (click)="onClick()"
      >
        <div class="icon-wrapper" [class.active]="isActive">
          <ng-icon
            [name]="iconName"
            [size]="'23'"
            [class.text-white]="isActive"
            class="icon-color"
          ></ng-icon>
        </div>
        <span *ngIf="!showOnlyIcons" class="ms-3 caption-color">{{
          caption
        }}</span>
      </a>
    </li>
  `,
  standalone: true,
  imports: [CommonModule, IconsModule],
  styleUrls: ['./zikata-menu-item.component.scss'],
})
export class MenuItemComponent {
  @Input() iconName = '';
  @Input() caption = '';
  @Input() showOnlyIcons = false;
  @Input() isActive = false;
  @Output() itemClick = new EventEmitter<void>();

  onClick() {
    this.itemClick.emit();
  }
}
